module.exports = __webpack_public_path__ + "static/media/1.b22faa28.png";